// extracted by mini-css-extract-plugin
var _1 = "v6W_JeRXVqPSaUmbk6kR";
var _2 = "LPvzn6XTaLhnmAJ4fFO9";
var _3 = "DjyxQloZYCwkhR8A8SCT";
var _4 = "aVQlltFBWkRZWMrsRHZA";
var _5 = "ArxxbgG9GP_GT3N_PYL1";
export { _1 as "textarea", _2 as "textareaDisabled", _3 as "textareaError", _4 as "textareaLabel", _5 as "textareaWrapper" }
